// extracted by mini-css-extract-plugin
export var fullWidthButton = "_zp-0";
export var tagInputDisabled = "_zp-1";